import { useWindowSize } from '@passkeys/hooks';
import TokenIcon from '@passkeys/ui/token-icon';

type AnimatedTokenIconsProps = {
  name: string;
  displayName: string;
};

const AnimatedTokenIcons = ({ name, displayName }: AnimatedTokenIconsProps) => {
  const bigSize = 80;
  const smallSize = 56;

  const { width } = useWindowSize();
  const icons = [
    ...Array.from({ length: Math.ceil(width / smallSize) | 1 }).keys(),
  ];

  return (
    <div className="relative flex flex-row items-center justify-center gap-x-3">
      <div className="absolute bottom-0 left-0 right-0 top-0 z-10 bg-gradient-to-r from-white from-10% via-transparent via-50% to-white to-90% theme-dark:from-[#151515] theme-dark:via-transparent theme-dark:to-[#151515]" />
      {icons.map((_, index) => {
        const isCentered = index === Math.floor(icons.length / 2);

        return (
          <TokenIcon
            key={index}
            name={name}
            displayName={displayName}
            size={isCentered ? bigSize : smallSize}
            className={isCentered ? 'animate-rotate-scale-up' : undefined}
          />
        );
      })}
    </div>
  );
};

export default AnimatedTokenIcons;
